import {months} from './_constants'

export const getQuarterMonths = (quarter: number, financialYear: string, month: string): string => {
  const monthIndex = months.findIndex((m) => m.toLowerCase() === month.toLowerCase())

  if (monthIndex === -1) {
    return 'Invalid Month'
  }

  if (quarter < 1 || quarter > 4) {
    return 'Invalid Quarter'
  }

  let financialYearStartMonthIndex = 0

  if (financialYear) {
    const parts = financialYear.split('-')
    const startMonth = parts[0]?.trim().toLowerCase()

    financialYearStartMonthIndex = months.findIndex((m) => m.toLowerCase() === startMonth)

    console.log(financialYearStartMonthIndex)

    if (financialYearStartMonthIndex === -1) {
      return 'Invalid Financial Year'
    }
  }

  const getExpectedQuarter = (monthIndex: number, start: number): number | undefined => {
    const adjustedMonthIndex = (monthIndex - start + months.length) % months.length
    if (adjustedMonthIndex >= 0 && adjustedMonthIndex <= 2) return 1
    if (adjustedMonthIndex >= 3 && adjustedMonthIndex <= 5) return 2
    if (adjustedMonthIndex >= 6 && adjustedMonthIndex <= 8) return 3
    if (adjustedMonthIndex >= 9 && adjustedMonthIndex <= 11) return 4
    return undefined
  }

  const expectedQuarter = getExpectedQuarter(monthIndex, financialYearStartMonthIndex)

  if (expectedQuarter !== quarter) {
    return `Month '${month}' does not fall in Quarter ${quarter} for the financial year '${financialYear}'`
  }

  let startMonthIndex: number
  switch (quarter) {
    case 1:
      startMonthIndex = financialYearStartMonthIndex
      break
    case 2:
      startMonthIndex = (financialYearStartMonthIndex + 3) % months.length
      break
    case 3:
      startMonthIndex = (financialYearStartMonthIndex + 6) % months.length
      break
    case 4:
      startMonthIndex = (financialYearStartMonthIndex + 9) % months.length
      break
    default:
      return 'Error determining start month'
  }

  const endMonthIndex = (startMonthIndex + 2) % months.length

  return `${months[startMonthIndex]}-${months[endMonthIndex]}`
}
